import { Link } from 'react-router-dom';

export function Pricing() {
  return (
    <section id="pricing" className="relative py-28 px-6 lg:px-8 bg-sg border-y border-line">
      {/* Visual connector line */}
      <div className="sc" aria-hidden="true">
        <svg width="2" height="24" viewBox="0 0 2 24">
          <line x1="1" y1="0" x2="1" y2="24" className="sc-line" stroke="#2563EB" strokeOpacity="0.3" strokeWidth="1.5" />
        </svg>
        <span className="sc-node" />
      </div>

      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-[32px] sm:text-[40px] font-extrabold tracking-tight text-ink mb-5">
          Currently in limited access.
        </h2>
        <p className="text-[16px] text-sub leading-relaxed mb-3">
          Pricing is built around your consent volume. We're onboarding a small number of data fiduciaries before public launch — to make sure the infrastructure performs at scale before it has to.
        </p>
        <p className="mono text-[12.5px] text-muted mb-10">
          If you're preparing for DPDP enforcement, reach out now. Waitlist spots close when capacity is reached.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Link to="/register" className="btn-p text-[14px] w-full sm:w-auto justify-center">
            Request Access{' '}
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </Link>
          <a href="#demo" className="btn-g text-[14px] w-full sm:w-auto justify-center">
            <svg className="w-4 h-4 text-sub" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            Book a 20-min Demo
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-line rounded-xl2 overflow-hidden border border-line">
          <div className="bg-card px-5 py-5 text-center">
            <div className="text-[13px] font-medium text-ink mb-1">Priced by</div>
            <div className="mono text-[12px] text-muted">Consent events / mo</div>
          </div>
          <div className="bg-card px-5 py-5 text-center">
            <div className="text-[13px] font-medium text-ink mb-1">Contracts</div>
            <div className="mono text-[12px] text-muted">Monthly or annual</div>
          </div>
          <div className="bg-card px-5 py-5 text-center">
            <div className="text-[13px] font-medium text-ink mb-1">Data ownership</div>
            <div className="mono text-[12px] text-muted">Always yours, always exportable</div>
          </div>
        </div>
      </div>
    </section>
  );
}
